<template>
    <div>
        <v-alert :type="alert_type" text v-if="alert_type">
         <pre>{{alert_text}}</pre>
        </v-alert>
        <div v-if="data_ready || no_content">
          <template v-if="no_content">
           <v-alert type="warning">
                  There are no members of panel matching given filters and timeframe.
                  No analysis content available, please change your setup.
           </v-alert>
          </template>
          <template v-else>
            <slot></slot>
          </template>
        </div>
        <div v-else>
            <v-row class="project-cards__row row">
                <v-col class="col-xs-12">
                    <ProjectCard
                            :title="loadingMessage"
                            :loading="loading">
                    </ProjectCard>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
    import ProjectCard from "./../ProjectCard";
    import Loader from "../../Loader";

    export default {
        name: "AnalysisPane",
        components: {ProjectCard, Loader},
        props: [
                "community",
                "project",
                "get_kpi_fn",
              ],
        data: () => ({
            loading: true,
            loadingMessage: "Computing ...",
            alert_type: null,
            alert_text: "",
            no_content: false,
            startDate: null,
            endDate: null,
            data_ready: false
        }),
        methods: {
            fetchKPIs() {
              this.no_content = false;
              this.data_ready = false;

              this.get_kpi_fn()
              .then(resp => {
                  this.loading = false;
                  // No content means the analysis is useless
                  this.no_content = false
                  if (resp.status == 204) {
                    this.no_content = true
                  } else {
                    this.startDate = this.project.timeframe_start;
                    this.endDate = this.project.timeframe_end;
                    this.data_ready = true;
                  }
              }).catch(err => {
                  console.log("AnalysiPane catch");
                  this.data_ready = false;
                  this.loading = false;
                  this.loadingMessage = "Computing analysis error"
                  this.alert_text = "Failed fetching analysis results!" + "\n" +
                    "ProjectId: " + this.project.id + "\n" +
                    "Error details: " + JSON.stringify(err, null, 4) ;
                  this.alert_type = 'error'
              })
            }
        },
        mounted() {
            this.fetchKPIs()
        },
        watch: {
            project: {
                handler: function (val) {
                    if (val && val.configuration.communities.length) {
                      // Check if timeframe changed
                      if ( this.startDate != val.timeframe_start ||
                           this.endDate != val.timeframe_end ) {
                        this.fetchKPIs();
                      }
                    }
                },
                deep: true
            },
            community: function (val) {
                  this.fetchKPIs();
            },
        }
    }
</script>
